import type { AxiosInstance } from "axios";
import { useClient } from "../state/client";
import { useQuery } from "@tanstack/solid-query";
import { initialized } from "../utils/initializedUtil";
import { minutes } from "../utils/timeUtil";
import type { MoreAppError } from "../MoreAppError";
import type CustomerId from "../state/CustomerId";

export type TrustLevel = "UNTRUSTED" | "SUSPICIOUS" | "NEUTRAL" | "TRUSTED";

export type TrustDto = {
  trustLevel: TrustLevel;
};

let client: AxiosInstance | null = null;

const init = (): void => {
  client = useClient();
};

const getClient = () => initialized(client, "client");

const TrustService = {
  getTrustLevel: (customerId: CustomerId) =>
    useQuery<TrustLevel, MoreAppError>(() => ({
      queryKey: ["customers", customerId, "trust"],
      queryFn: async () => {
        const response = await getClient().get<TrustDto>(`api/v1.0/customers/${customerId}/trust`);
        return response.data?.trustLevel;
      },
      staleTime: minutes(5),
    })),
  isTrusted: (customerId: CustomerId): boolean => TrustService.getTrustLevel(customerId).data === "TRUSTED",
  init: init,
};

export default TrustService;
